export const { format: formatPrice } = new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
});

export const  formatCPF = (document: any) => {
    if(document){
      document = ('00000000000' + document.toString()).slice(-11);
      return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    else
      return null;
}

export const formatDate = (date: any, time: boolean = true) => {
    if(date)
      if(time){
        return new Intl.DateTimeFormat('pt-BR', {
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric',
          hour12: false
        }).format(new Date(date))
      }
      else{
        return new Intl.DateTimeFormat('pt-BR').format(new Date(date))
      }
    else
      return ''

};

export const getFirstLetterFromWords = (value: any, words: number): string => {
  return value.split(' ').slice(0, words).map(word => word[0]).join('');
}

export const truncateString = (str: string, n: number): string => {
  let firstLetter = str.slice(0,1).toUpperCase();
  return firstLetter + str.substring(1).split(" ").splice(0, n).join(" ").toLowerCase();
}

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const base64toDocument = (data: string, fileName: string, fileExtension: string, isPaymentBoleto: boolean, isImage?: boolean) => {
  
  let source = `data:application/pdf;base64,${data}`;
  if(isPaymentBoleto){
    source = data;
  }
  if(isImage){
    source = `data:image/${fileExtension};base64,${data}`;
  }
  const link = document.createElement("a");
  link.href = source;
  link.download = `${fileName}.${fileExtension}`;
  link.click();

  return link;
};